var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable:no-inferrable-types */
import { Injectable } from '@angular/core';
import { Toast } from './toast-component';
/**
 * Configuration for an individual toast.
 */
var ToastConfig = (function () {
    function ToastConfig(config) {
        if (config === void 0) { config = {}; }
        /** show close button */
        this.closeButton = false;
        /** time to close after a user hovers over toast */
        this.extendedTimeOut = 1000;
        /** show progress bar */
        this.progressBar = false;
        /** time to live */
        this.timeOut = 5000;
        /** allow html in message */
        this.enableHtml = false;
        this.toastClass = 'toast';
        this.positionClass = 'toast-top-right';
        this.titleClass = 'toast-title';
        this.messageClass = 'toast-message';
        /** clicking on toast dismisses it */
        this.tapToDismiss = true;
        /** the Angular component to be shown */
        this.toastComponent = Toast;
        /** Helps show toast from a websocket or from event outside Angular */
        this.onActivateTick = false;
        this.closeButton = config.closeButton || this.closeButton;
        if (config.extendedTimeOut === 0) {
            this.extendedTimeOut = config.extendedTimeOut;
        }
        else {
            this.extendedTimeOut = config.extendedTimeOut || this.extendedTimeOut;
        }
        this.progressBar = config.progressBar || this.progressBar;
        if (config.timeOut === 0) {
            this.timeOut = config.timeOut;
        }
        else {
            this.timeOut = config.timeOut || this.timeOut;
        }
        this.enableHtml = config.enableHtml || this.enableHtml;
        this.toastClass = config.toastClass || this.toastClass;
        this.positionClass = config.positionClass || this.positionClass;
        this.titleClass = config.titleClass || this.titleClass;
        this.messageClass = config.messageClass || this.messageClass;
        if (config.tapToDismiss !== undefined) {
            this.tapToDismiss = config.tapToDismiss;
        }
        this.toastComponent = config.toastComponent || this.toastComponent;
        this.onActivateTick = config.onActivateTick || this.onActivateTick;
    }
    return ToastConfig;
}());
export { ToastConfig };
var ToastrIconClasses = (function () {
    function ToastrIconClasses() {
    }
    return ToastrIconClasses;
}());
export { ToastrIconClasses };
ToastrIconClasses.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ToastrIconClasses.ctorParameters = function () { return []; };
/**
 * Global Toast configuration
 */
var ToastrConfig = (function (_super) {
    __extends(ToastrConfig, _super);
    function ToastrConfig(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        /** max toasts opened. Toasts will be queued */
        _this.maxOpened = 0;
        /** dismiss current toast when max is reached */
        _this.autoDismiss = false;
        _this.iconClasses = {
            error: 'toast-error',
            info: 'toast-info',
            success: 'toast-success',
            warning: 'toast-warning',
        };
        /** new toast placement */
        _this.newestOnTop = true;
        /** block duplicate messages */
        _this.preventDuplicates = false;
        _this.maxOpened = config.maxOpened || _this.maxOpened;
        _this.autoDismiss = config.autoDismiss || _this.autoDismiss;
        if (config.iconClasses) {
            _this.iconClasses.error = _this.iconClasses.error || config.iconClasses.error;
            _this.iconClasses.info = _this.iconClasses.info || config.iconClasses.info;
            _this.iconClasses.success = _this.iconClasses.success || config.iconClasses.success;
            _this.iconClasses.warning = _this.iconClasses.warning || config.iconClasses.warning;
        }
        _this.newestOnTop = config.newestOnTop || _this.newestOnTop;
        _this.preventDuplicates = config.preventDuplicates || _this.preventDuplicates;
        return _this;
    }
    return ToastrConfig;
}(ToastConfig));
export { ToastrConfig };
ToastrConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ToastrConfig.ctorParameters = function () { return [
    { type: ToastrConfig, },
]; };
var ToastData = (function () {
    function ToastData() {
    }
    return ToastData;
}());
export { ToastData };



//////////////////
// WEBPACK FOOTER
// ./~/ngx-toastr/toastr-config.js
// module id = 24
// module chunks = 4